import { IUnityInstance } from './loader';

let handler: undefined | (() => void);

export function registerResumeContextHandler(instance: IUnityInstance) {
  handler = () => {
    try {
      if (document.visibilityState === 'visible') {
        instance.audioContext?.resume();
      }
    } catch (error) {
      // for now we just log the error into the console
      // we can implement better error handling if we see cases when its needed
      console.warn('Resume AudioContext failed!', error);
    }
  };
  document.addEventListener('visibilitychange', handler);
}

export function unregisterResumeContextHandler() {
  if (!handler) {
    return;
  }
  document.removeEventListener('visibilitychange', handler);
  handler = undefined;
}
